// authSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

interface AuthState {
  user: User | null;
}

interface User {
  FirmName: string;
  PersonName: string;
  UserRole: string;
  EmployeeID:string;
  Designation:string;
  Department:string;
  jwtToken: string;
  UserID: number;
  UserTypeID: number;
  ProfileImagePath: string;
}

const initialState: AuthState = {
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<User>) => {
     
      state.user = action.payload;
    },
    logout: (state) => {
      state.user = null;
    },
    initialize: (state, action: PayloadAction<AuthState>) => {
      state.user = action.payload.user;
    },
  },
});

export const { login, logout, initialize } = authSlice.actions;
export const selectAuth = (state: RootState) => state.auth;
export default authSlice.reducer;


